// src/app/core/services/server-error.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServerErrorService {
  private serverErrorSubject = new BehaviorSubject<boolean>(false);
  public serverError$: Observable<boolean> = this.serverErrorSubject.asObservable();
  private previousUrl: string = '/';

  constructor() {
    // Check localStorage on initialization
    const hasError = localStorage.getItem('serverError') === 'true';
    this.serverErrorSubject.next(hasError);

    // Restore previous URL if exists
    const savedUrl = localStorage.getItem('previousUrl');
    if (savedUrl) {
      this.previousUrl = savedUrl;
    } else {
      // Default to login if no previous URL
      this.previousUrl = '/login';
    }
  }

  setServerError(hasError: boolean, currentUrl?: string): void {
    if (hasError) {
      localStorage.setItem('serverError', 'true');

      // Save the URL where error occurred
      if (currentUrl && currentUrl !== '/server-error') {
        // Don't save empty path or just '/'
        if (currentUrl !== '/' && currentUrl !== '') {
          this.previousUrl = currentUrl;
          localStorage.setItem('previousUrl', currentUrl);
        } else {
          // If error happened on root, default to login
          this.previousUrl = '/login';
          localStorage.setItem('previousUrl', '/login');
        }
      }
    } else {
      localStorage.removeItem('serverError');
      // Don't remove previousUrl yet - we need it for retry
    }
    this.serverErrorSubject.next(hasError);
  }

  hasServerError(): boolean {
    return this.serverErrorSubject.value;
  }

  clearServerError(): void {
    this.setServerError(false);
    // Clear the previous URL after successful retry
    localStorage.removeItem('previousUrl');
    this.previousUrl = '/login'; // Reset to default
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }

  setPreviousUrl(url: string): void {
    if (url && url !== '/server-error') {
      this.previousUrl = url;
      localStorage.setItem('previousUrl', url);
    }
  }
}